'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js'], function (Vue) {
	Vue.component('word-random-edit', {
		props: ['word', 'initData'],
		data: function () {
			return {

			};
		},
		computed: {
			lettersToHide: function () {
				var lettersCount = this.word.word.replace(' ', '').length;
				
				var lettersToHide = [];
				for (var i = 1; i <= lettersCount; i++) {
					lettersToHide.push(i);
				}
				
				return lettersToHide;
			}
		},
		template:
			'<div>' +
				'<div class="form-group">' +
					'<label>{{initData.translations.howManyLettersToHide}}</label>' +
					'<select class="form-control" v-model="word.lettersToHideCount">' +
						'<option v-for="letter in lettersToHide" :value="letter">{{letter}}</option>' +
					'</select>' +
				'</div>' +
			'</div>',
	});
});
